module.exports = __webpack_public_path__ + "videos/ada-cube.567e89a.mp4";